import { FC } from "react";

import { ColLabel } from "components/light-table";
import { IAgent } from "store/entities/agents";
import { ISort } from "store/views/agents";

import { AddAgentRow } from "./AddAgentRow";
import { AgentRow } from "./AgentRow";
import { AgentLightTable, AgentLightTableHead, AgentLightTableWrapper, ColumnWidths } from "./styled";

interface IProps {
  sort: ISort;
  agents: IAgent[];
  selectedAgent?: IAgent;
  onSort(field: string, desc: boolean): void;
  onSelectAgent(agentLogin: string): void;
  onDoubleClickAgent(agentLogin: string): void;
  onAddAgentClick(): void;
}

export const HelpDeskAgentsList: FC<IProps> = ({
  sort,
  agents,
  selectedAgent,
  onSort,
  onSelectAgent,
  onDoubleClickAgent,
  onAddAgentClick,
}) => (
  <>
    <AgentLightTableHead>
      <thead>
        <tr>
          <th style={{ width: ColumnWidths.Avatar }} />
          <th>
            <ColLabel active={sort.field === "name"} desc={sort.desc} onClick={() => onSort("name", !sort.desc)}>
              Name
            </ColLabel>
          </th>
          <th style={{ width: ColumnWidths.Role }}>
            <ColLabel active={sort.field === "role"} desc={sort.desc} onClick={() => onSort("role", !sort.desc)}>
              Role
            </ColLabel>
          </th>
          <th style={{ width: ColumnWidths.AutoAssignment }}>
            <ColLabel
              active={sort.field === "auto-assignment"}
              desc={sort.desc}
              onClick={() => onSort("auto-assignment", !sort.desc)}
            >
              Auto-assignment
            </ColLabel>
          </th>
          <th style={{ width: ColumnWidths.InvitationStatus }} />
        </tr>
      </thead>
    </AgentLightTableHead>
    <AgentLightTableWrapper>
      <AddAgentRow onClick={onAddAgentClick} />
      <AgentLightTable>
        <tbody>
          {agents.map((agent: IAgent) => (
            <AgentRow
              key={agent.email}
              selected={agent === selectedAgent}
              agent={agent}
              onSelectAgent={onSelectAgent}
              onDoubleClickAgent={onDoubleClickAgent}
            />
          ))}
        </tbody>
      </AgentLightTable>
    </AgentLightTableWrapper>
  </>
);
